import React, { useState } from 'react';

function CostTracker({ apiCalls, costs, totalCost, totalCalls, leadsCount }) {
  const [isExpanded, setIsExpanded] = useState(false);

  const costPerLead = leadsCount > 0 ? totalCost / leadsCount : 0;

  return (
    <div className="cost-tracker">
      <div className="cost-summary" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="cost-total">
          <span className="cost-label">Est. Cost</span>
          <span className="cost-value">${totalCost.toFixed(4)}</span>
        </div>
        <span className="cost-expand">{isExpanded ? '▼' : '▶'}</span>
      </div>

      {isExpanded && (
        <div className="cost-details">
          <div className="cost-row">
            <span>Geocoding</span>
            <span>{apiCalls.geocoding} calls</span>
            <span>${costs.geocoding.toFixed(4)}</span>
          </div>
          <div className="cost-row">
            <span>Dynamic Maps</span>
            <span>{apiCalls.mapsJavaScript} loads</span>
            <span>${costs.mapsJavaScript.toFixed(4)}</span>
          </div>
          <div className="cost-row">
            <span>Autocomplete</span>
            <span>{apiCalls.placesAutocomplete} calls</span>
            <span>${costs.placesAutocomplete.toFixed(4)}</span>
          </div>
          <div className="cost-row cost-row-total">
            <span>Total</span>
            <span>{totalCalls} calls</span>
            <span>${totalCost.toFixed(4)}</span>
          </div>
          <div className="cost-note">
            Geocode $0.0005/req, Maps $0.0007/load
          </div>
          <div className="cost-note" style={{ marginTop: '0.25rem', opacity: 0.7 }}>
            Estimate only. Check Google Cloud Billing for actual costs.
          </div>
        </div>
      )}
    </div>
  );
}

export default CostTracker;
